<template lang="pug">
v-dialog(v-model="dialog", width="92%", scrollable)
  template(#activator="{ on }")
    slot(name="activator" v-bind="{ on }")
  v-card(dark).px-4
    v-list-item
      v-list-item-title.title Выбор шаблона для быстрого ответа
      v-list-item-action
        v-btn(icon @click="dialog = false" color="white")
          v-icon mdi-close
    p.mb-2.caption.text--darken-1 После выбора шаблона он будет автоматическе вставлен в поле
    v-tabs(v-model="tab" background-color="transparent").transparent
      v-tab.transparent Шаблоны
      v-tab.transparent Автоответы
      v-tabs-items(v-model="tab" background-color="transparent").transparent
        v-tab-item
          v-row
            v-col(cols=4)
              v-list.class(dark)
                v-list-item(v-for="item in items" :key="item.id" @click="form.question_category_id = item.id")
                  v-list-item-content
                    v-list-item-title {{item.name}}
            v-col(cols=8)
              v-text-field(
                v-model="form.name"
                dark
                placeholder="Поиск"
                hide-details
                filled
              )
              v-list(v-if="userTemplates.length" color="transparent" dark).class
                template(v-for="(userTemplate, index) in userTemplates")
                  v-list-item(
                    :key="userTemplate.id"
                    @click="selectTemplate(userTemplate.text)"
                  )
                    v-list-item-content
                      v-list-item-title.text-wrap(v-text="userTemplate.name")
              v-alert(v-else type="info" text) Шаблоны не найдены
        v-tab-item
          v-text-field(
            v-model="searchName"
            label="Название вопроса"
            filled
            dark
            hide-details
          )
          v-alert.mt-2(type="info" v-if="!hints.length") Еще нет типовых вопросов
          v-list.class(v-else three-line color="transparent" dark)
            template(v-for="hint in hints" )
              v-list-item(:key="hint.id" @click="selectTemplate(hint.text)")
                v-list-item-content
                  v-list-item-title {{ hint.title }}
                  v-list-item-subtitle {{ hint.text }}
              v-divider
    //- select-template-category(
    //-   v-model="form.question_category_id"
    //-   dark
    //-   filled
    //-   :project-id="question.project_id"
    //- )
</template>

<script>
import autoAnswerService from '@/services/API/autoAnswer';
import { CRUDAnswerTemplates, CRUDQuestionCategory } from '@/services/API/_crud';
import SelectTemplateCategory from '@/components/inputs/SelectTemplateCategory.vue';
import { fetchFaqTemplates } from '@/services/API/_directory';

export default {
  components:{ SelectTemplateCategory },
  props: {
    question: { type: Object, default: null },
  },
  data() {
    return {
      searchName: null,
      items: [],
      hints: [],
      selected: null,
      dialog: false,
      tab: 0,
      faqTemplates: [],

      form: {
        name: '',
        question_category_id: null,
      },
      loadingUserTemplates: false,
      userTemplates: [],
    };
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler() {
        this.fetchUserTemplates();
      },
    },
    searchName() {
      this.getHints();
    },
    dialog:{
      handler(v) {
        if (v) this.fetchFaqQuestions();
      },
    },
  },
  created() {
    this.loadItems();
    this.getHints();
  },
  methods: {
    async loadItems() {
      const params = {
        'search[name]' :this.search,
        'per-page': -1,
        'search[project_id]': this.question.project_id,
      };

      await CRUDQuestionCategory.getAll(params).then((response) => {
        this.items = response.data.data;
        this.loading = false;
      });
    },
    async getHints() {
      const search = {
        'search[title]': this.searchName,
        'search[project_id]': this.question.project_id,
        'per-page': -1,
      };
      try {
        const response = await autoAnswerService.getHints({ ...search, expand: 'projects,require_tags,not_require_tags' });
        this.hints = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },

    async fetchUserTemplates() {
      const params = {
        'search[name]': this.form.name,
        'search[question_category_id]': this.form.question_category_id,
        'search[project_id]': this.question.project_id,
        'per-page': 5,
      };
      this.loadingUserTemplates = true;

      const response = await CRUDAnswerTemplates.getAll(params);

      this.userTemplates = response.data.data;
      this.loadingUserTemplates = false;
    },
    async fetchFaqQuestions() {
      const response = await fetchFaqTemplates();
      this.faqTemplates = response.data.data;
    },
    selectTemplate(text) {
      this.$emit('select', text);
      this.$toast.success('Шаблон был вставлен');
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss">
.class {
  height: 70vh;
  overflow: auto;
  border: 1px solid black !important;
}
</style>
